import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'axed-dom-breakcrumb',
  templateUrl: './dom-breakcrumb.component.html',
  styleUrls: ['./dom-breakcrumb.component.css']
})
export class DomBreakcrumbComponent implements OnInit {
  nodes: string[] = [];

  constructor() {}

  ngOnInit() {}

  showSelection(selection: Selection) {
    if (selection === undefined) {
      this.nodes = ['none'];
    } else {
      const collectNodes = [];
      let node = selection.focusNode;
      let reachedTop = node === undefined || node === null;
      while (!reachedTop) {
        switch (node.nodeType) {
          case Node.ELEMENT_NODE: // element node
            const asElement = node as Element;
            if (asElement !== undefined) {
              const name = asElement.getAttribute('data-tagname');
              if (asElement.className === 'sws-xml-editor-textarea') {
                reachedTop = true;
              } else {
                collectNodes.unshift(name);
              }
            }
        }
        node = node.parentElement;
        if (node === undefined || node == null) {
          reachedTop = true;
        }
      }
      this.nodes = collectNodes;
    }
  }
}
